export default __webpack_public_path__ + "static/benedikt-meurer-c0b2e26d0fac016c342501d03529728c.jpg";